import { CardValidatorUnordered } from './card/CardValidatorUnordered.ts';
export class BankValidator {
    get hideBankCards() {
        return this.state.hideBankCards;
    }
    constructor(state){
        this.state = state;
        this.resourceCards = new CardValidatorUnordered(this.state.resourceCards);
    }
}
